module.exports = __webpack_public_path__ + "assets/2c34fcee7f33bfd4ea14039860148b30.png";